import { useState } from "react";
import { BellRing } from "lucide-react";

import { publicSignup } from "../../lib/tournamentApi";

/** "Tell me about the next tournament" — one email, adults / parents only. */
export default function NextTournamentSignup({ slug, enabled }) {
  const [email, setEmail] = useState("");
  const [adult, setAdult] = useState(false);
  const [state, setState] = useState(null);
  if (!enabled) return null;
  async function submit(e) {
    e.preventDefault();
    try { await publicSignup(slug, { email, adult_confirm: adult }); setState("ok"); }
    catch (err) { setState(err.message || "Couldn't sign up."); }
  }
  if (state === "ok") return <div data-testid="signup-done" style={box}>You're on the list. We'll email you about the next tournament.</div>;
  return (
    <form onSubmit={submit} data-testid="signup-box" style={box}>
      <div style={{ display: "flex", gap: 8, alignItems: "center", fontWeight: 800 }}><BellRing size={16} aria-hidden="true" /> Hear about the next tournament</div>
      <div style={{ display: "flex", gap: 8, marginTop: 10, flexWrap: "wrap" }}>
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" data-testid="signup-email"
               style={{ flex: 1, minWidth: 180, padding: "10px 12px", borderRadius: 999, border: "none", fontSize: 14 }} />
        <button type="submit" disabled={!adult} data-testid="signup-submit"
                style={{ background: "#2E7D52", color: "#fff", border: "none", borderRadius: 999, padding: "10px 18px", fontWeight: 800, cursor: adult ? "pointer" : "not-allowed", opacity: adult ? 1 : 0.5 }}>Notify me</button>
      </div>
      <label style={{ display: "flex", gap: 8, fontSize: 12, marginTop: 10, opacity: 0.85 }}>
        <input type="checkbox" checked={adult} onChange={(e) => setAdult(e.target.checked)} data-testid="signup-adult" />
        I'm 18 or older, or a parent/guardian. One email per new tournament; unsubscribe any time.
      </label>
      {state && <div data-testid="signup-error" style={{ fontSize: 12, color: "#ff9b8f", marginTop: 6 }}>{state}</div>}
    </form>
  );
}

const box = { background: "rgba(245,240,232,0.06)", border: "0.5px solid rgba(245,240,232,0.2)", borderRadius: 14, padding: 16, marginTop: 24, color: "#F5F0E8" };
